import React, { useCallback } from 'react';
import { GroupSearchResult } from 'graphql/types';
import { GroupSelectCount } from '../constant';
import { useGroupSelectLabel } from '../hooks/useGroupSelectType';
import { GroupSelect } from '../GroupSelect';
import { GroupSelectDropdownProp } from '../types';
import { useSelectSearchAction } from './hooks/useSelectSearchAction';

const emptyData: GroupSearchResult[] = [];

export const EmployeeTypesSelect: React.FC<GroupSelectDropdownProp> = ({
  groupType,
  rowID,
  defaultValues,
  classes
}: GroupSelectDropdownProp) => {
  const {
    searchHandler,
    data: { employeeTypes: employeeTypesData },
    loading: { employeeTypes: employeeTypesLoading }
  } = useGroupSelectLabel();

  const employeeTypes =
    employeeTypesData?.groupsSearch?.employeeTypes.items || emptyData;
  const hasMore = employeeTypes.length === GroupSelectCount;
  const { handleSearch } = useSelectSearchAction(searchHandler);

  const onOpen = useCallback(() => {
    handleSearch(groupType, null);
  }, [groupType, handleSearch]);

  return (
    <GroupSelect
      groupType={groupType}
      onOpen={onOpen}
      handleSearch={handleSearch}
      options={employeeTypes}
      hasMore={hasMore}
      loading={employeeTypesLoading}
      rowID={rowID}
      defaultValues={defaultValues}
      classes={classes}
    />
  );
};
